import React from "react";
import { languageLabels } from "./LanguageSelector";
import "./LanguageBadges.css";

const LanguageBadges = ({ codes = [], infoSource, title }) => {
  if (!codes.length) return null;
  return (
    <section className="language-badges">
      {title && <h4>{title}</h4>}
      <div>{languageLabels(codes, infoSource).map(({ code, label }) => <span key={code}>{label}</span>)}</div>
    </section>
  );
};

export default LanguageBadges;
